export default __webpack_public_path__ + "static/media/home-banner.e54f14ba.webp";